import { render, staticRenderFns } from "./wwopendata.vue?vue&type=template&id=097465fc&"
import script from "./wwopendata.vue?vue&type=script&lang=js&"
export * from "./wwopendata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports